import { IonIcon, IonRouterLink } from '@ionic/react';
import React from 'react';

import Spacer from '@/components/common/spacer/Spacer';
import useInView from '@/hooks/useInView';
import { ROUTES } from '@/utils/routes';

import './Step.css';

interface StepProps {
  step: {
    id: number;
    icon: string;
    title: string | React.ReactNode;
    description: string;
    image: string;
  };
}

const Step: React.FC<StepProps> = ({ step }) => {
  const copy = {
    tryItNow: 'Try it now'
  };

  const [ref, inView] = useInView({
    threshold: 0.12,
    triggerOnce: true
  });

  return (
    <div className={`step ${inView ? 'inView' : ''}`} ref={ref}>
      <div className="stepIconContainer">
        <div className="stepIcon">
          <IonIcon icon={step.icon} />
        </div>
        {step.id !== 5 && <div className="stepLine"></div>}
      </div>
      <div className="stepContent">
        <div className="stepImageContainer">
          <img
            src={step.image}
            alt={`Step ${step.id}`}
            className={`stepImage ${step.id === 3 ? 'center' : ''}`}
          />
        </div>
        <Spacer top={16} bottom={8}>
          <div className="stepHeader">
            <p className="stepNumber">{step.id}</p>
            <p className="stepTitle">
              <span className="stepTitleSpacer"></span>
              {step.title}
            </p>
          </div>
        </Spacer>
        <p className="stepDetails">
          {step.description}{' '}
          {step.id === 1 && (
            <IonRouterLink href={ROUTES.DEMO} target="_blank">
              {copy.tryItNow}
            </IonRouterLink>
          )}
        </p>
      </div>
    </div>
  );
};

export default Step;
